import { render, staticRenderFns } from "./userRoleDetailNC.vue?vue&type=template&id=19a5db38&"
import script from "./userRoleDetailNC.vue?vue&type=script&lang=js&"
export * from "./userRoleDetailNC.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetailNC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports